import React from 'react';
import { TableRow, TableCell, Icon } from '@weezevent/nacre';
import PutForSaleRateRow from './putForSaleRateRow';
import Style from '../editCrossSelling.module.css';

export default function PutForSaleRateGroupRow({ rateGroup, quotas, isSubGroup = false, productId, event, category, forSaleArray, setForSaleArray }) {
    return (
        <>
            <TableRow className={Style['top-groupe-mev']}>
                <TableCell colSpan={5} className={isSubGroup && Style['top-subgroup-mev']}>
                    {isSubGroup && <Icon name="link-group" size="mini" />}
                    <Icon name="folder-open" /> <span>{rateGroup.name || rateGroup.group_template.name}</span>
                </TableCell>
            </TableRow>
            {rateGroup.rates.map(r => (
                <PutForSaleRateRow
                    key={r.id}
                    productId={productId}
                    rate={r}
                    event={event}
                    rateGroup={rateGroup}
                    category={category}
                    forSaleArray={forSaleArray}
                    setForSaleArray={setForSaleArray}
                    quotas={quotas}
                />
            ))}
            {rateGroup.children.map(g => (
                <PutForSaleRateGroupRow
                    key={g.id}
                    rateGroup={g}
                    isSubGroup={true}
                    productId={productId}
                    event={event}
                    category={category}
                    forSaleArray={forSaleArray}
                    setForSaleArray={setForSaleArray}
                    quotas={quotas}
                />
            ))}
        </>
    );
}
